export default __webpack_public_path__ + "static/media/logo_white.aa7710f1.svg";